module.exports = __webpack_public_path__ + "img/31_8.b3bb60bb.png";